import { useEffect, useState } from "react";
import { API } from "@/App";
import axios from "axios";

const Ring = ({ suit, drawn, total, palette }) => {
  const r = 26;
  const circ = 2 * Math.PI * r;
  const pct = total ? drawn / total : 0;
  return (
    <div className="flex flex-col items-center" data-testid={`suit-ring-${suit.toLowerCase()}`}>
      <div className="relative w-16 h-16">
        <svg viewBox="0 0 64 64" className="w-16 h-16 -rotate-90">
          <circle cx="32" cy="32" r={r} fill="none" stroke={`${palette.primary}22`} strokeWidth="6" />
          <circle
            cx="32" cy="32" r={r} fill="none"
            stroke={pct >= 1 ? "#D97706" : palette.primary}
            strokeWidth="6" strokeLinecap="round"
            strokeDasharray={circ}
            strokeDashoffset={circ * (1 - pct)}
            style={{ transition: "stroke-dashoffset 0.8s ease" }}
          />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center text-xs font-bold" style={{ color: pct >= 1 ? "#B45309" : palette.text }}>
          {drawn}/{total}
        </span>
      </div>
      <p className="text-[11px] font-semibold mt-1" style={{ color: palette.text }}>{suit}</p>
    </div>
  );
};

export const SuitCollection = ({ token, palette, refreshKey = 0 }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/lightdeck/collection`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setData(r.data))
      .catch(() => {});
  }, [token, refreshKey]);

  if (!data) return null;
  return (
    <div className="mt-4 rounded-xl p-4" style={{ backgroundColor: `${palette.primary}08`, border: `1px solid ${palette.primary}22` }} data-testid="suit-collection">
      <p className="text-xs font-bold uppercase tracking-widest mb-3 text-center" style={{ color: "#B08A3E" }}>
        Your Collection · {data.total_drawn} of {data.total_cards} cards
      </p>
      <div className="grid grid-cols-3 gap-3">
        {data.suits.map((s) => (
          <Ring key={s.suit} suit={s.suit} drawn={s.drawn} total={s.total} palette={palette} />
        ))}
      </div>
    </div>
  );
};
